<template>
    <div>
        <div>

            
                <div style="position: fixed;width: 100%;max-width: 540px;min-width: 320px;z-index: 100;top:0;">
                   <div style="background-color: white;">
                    <div class="fanhui" @click="$router.replace($route.query.type?($route.query.type==1?'/first/hexiaopage?hexiao=1':'/first/hexiaopage'):'/getdata')"
                    >

                        <a class="icon icon-109" style="flex:1;font-size: 18px;color: rgb(255, 255, 255);">返回</a>
                    <div style="font-size: 18px;color:white;">详细信息</div>
                    <div style="flex:1"></div>
                    </div>	
                   </div>

                    <!-- <div style="display: flex;justify-content: space-around;">
                        <van-button type="primary" @click="fuzhi">一键复制</van-button>
                        <van-button type="primary" @click='download'>下载excel</van-button>
                        <van-button type="primary" @click='downloadword'>下载world</van-button>
                        <van-button type="primary" @click = "deleteinfo">删除</van-button>
                    </div> -->


           <div style="display: flex;justify-content: space-around;">
            <div style="padding-left: 10px;padding-right: 10px;margin-top: 10px;margin-bottom: 10px;
            border: solid 1px rgb(238, 190, 210);border-radius: 5px;color:rgb(231, 94, 151) ;
            "
             @click="fuzhi"
            >
            一键复制
            </div>


           </div>         
          

                </div>	
               
			
                <br>
        <br>
        <br>
 
       
         <div style="display: flex;flex-direction: column;align-items: center;">   



             <div style="width: 95%;background-color: white;display:flex;justify-content: center;">

             <div style="width: 98%;">
       

        <br>


        <div  style="user-select:text;display: flex;flex-direction: column;align-items: center;word-wrap: break-word;">
            <div id="xuan" style="width:95%">
                
                <center  style="user-select:text; "><h2>编号:{{$route.query.hi}}
                    <!-- 详情信息{{hexiaodone?'(已核销)':'(未核销)'}}{{$route.query.type?($route.query.type==1?"(已核销)":"(未核销)"):""}} -->
                </h2>
                    <!-- <div style="border:solid 1px rgb(129, 127, 127);width: 100px;">已核销√</div> -->
                
                </center>
                <center>创建时间：{{createtime}}</center>
             
            <div style="display: flex;justify-content: center;">
                <div
                v-if="$route.query.type==0"
                style="padding-left: 10px;padding-right: 10px;margin-top: 10px;margin-bottom: 10px;
                border: solid 1px rgb(100, 98, 99);border-radius: 5px;color:rgb(124, 117, 120) ;
                "
                @click="hexiao"
                >
               手动核销
                </div>
            </div>
                <br>
                <div v-for="(v,i) in datas" >
                    <div v-if='v.zj==="Uploader"'>
                        <div>
                            {{v.name}}:                          
                        </div>  
                            <div v-for="(va,ke) in v.val">                             
                                <img :src="va.data" style="width: 100%;">
                            </div>
                    </div>
                    <div v-else-if="!v.zj&&v.name=='用户基本信息'">
                        {{v.name}}:
                       <div v-html="changeyou(v.val)"></div>
                    </div>
                    <div v-else >
                        {{v.name}}:{{v.val}}
                                          
                    </div>
                </div>

                
              </div>
              <br>
              <br>
              <br>
              <br>
              

            </div>
        </div>
        </div>  
<br>
<br>
<br>
        </div>  

            </div>
            </div>
   
</template>


<script>
          import axios from '@/js/axios.js'
            import {instance} from '@/js/axios.js'
        import Vue from 'vue';
    	import { Sticky,Button } from 'vant';
        Vue.use(Sticky);
        Vue.use(Button);
export default{
    data(){
        return{
            datas:[],
            createtime:'1990-01-01 00:00:00',
            hexiaodone:""
        }
    },
    methods:{
        hexiao(){
            
         
            if(this.$route.query.type==0){
                axios.post('/power/shoudonghexiao',{id:this.$route.query.id}).then(res=>{
                  
                    if(res.msg){
                     weui.alert(res.msg);
                  }
                })
            }
            
        },
        changeyou(val){
          let link =  val.replace(/(https:.+132)/,'<img src=$1 width=20%>')
        //   console.log(link);
          
            return link;
        },
        deleteinfo(){
            weui.dialog({
      title: '确定删除此数据？',
      content: '删除后将无法再次恢复，请谨慎操作',
      className: 'custom-classname',
      buttons: [{
          label: '取消',
          type: 'default',
          onClick: function () { 
 }
      }, {
          label: '确定',
          type: 'primary',
          onClick:  () => { 
			  					
                var loading = weui.loading('正在删除...');
                axios.post('/power/deletedata',{id:this.$route.query.id}).then(res=>{
                    if(res.code==200){
                        loading.hide();
                        weui.toast('删除成功', 2000);  
                        this.$router.replace('/first/getdata');
                        // console.log(res.data);
                        
                    }else{
                        loading.hide();
                        weui.toast('删除失败', 2000);  
                        // console.log(res.data);
                        
                    }
                    
                })


  
		 
		   }
      }]
  });
            
        },
        fuzhi(){
            const range = document.createRange();
        range.selectNode(document.getElementById('xuan'));
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }
        selection.addRange(range);
        document.execCommand("Copy");
        weui.toast('复制成功', 2000);
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }

        },
        download(){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
         
        return  weui.alert('请用电脑下载');
        }


        var loading = weui.loading('正在生成..');
    　　instance.post('/downloads/qdexdata',{id:this.$route.query.id}).then(res => {
        loading.hide();
            　　//这里res.data是返回的blob对象   
    　　var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    　　var downloadElement = document.createElement('a');
    　　var href = window.URL.createObjectURL(blob); //创建下载的链接
    　　downloadElement.href = href;
   let idd = this.$route.query.hi;
    　　downloadElement.download = '详情信息'+idd+'.xlsx'; //下载后文件名
    　　document.body.appendChild(downloadElement);
    　　downloadElement.click(); //点击下载
    　　document.body.removeChild(downloadElement); //下载完成移除元素
    　　window.URL.revokeObjectURL(href); //释放掉blob对象
　})


        },
        downloadword(){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
         
         return  weui.alert('请用电脑下载');
         }
 

         var loading = weui.loading('正在生成..');
    　　instance.post('/downloads/qdword',{id:this.$route.query.id}).then(res => {
        loading.hide();
            　　//这里res.data是返回的blob对象 
    　　var blob = new Blob([res.data], {type: 'application/msword;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    　　var downloadElement = document.createElement('a');
    　　var href = window.URL.createObjectURL(blob); //创建下载的链接
    　　downloadElement.href = href;
    let cid = this.$route.query.hi;
    　　downloadElement.download = '编号'+cid+'详细信息.docx'; //下载后文件名
    　　document.body.appendChild(downloadElement);
    　　downloadElement.click(); //点击下载
    　　document.body.removeChild(downloadElement); //下载完成移除元素
    　　window.URL.revokeObjectURL(href); //释放掉blob对象
　})  
        }
    },
created(){
        
    
        
},
activated(){    
    document.title = '查看数据详情' 
    axios.post('/zzhpower/qdgetdata',{id:this.$route.query.id}).then(res=>{
        if(res.code ==111){
            this.$router.replace('/');
        }
      
        this.datas = res.datas;
        this.createtime = res.createtime;
        this.hexiaodone = res.hexiaodone
    })
 },
 deactivated(){
     this.datas = [];
     
 }

}
</script>


<style lang="less">

    .fanhui{
        background-color: rgb(112, 177, 182);
        height: 50px;
        width: 100%;
        display: flex;
        align-items:center;
    }

    .fanhui:active{
        opacity: .5;
    }

</style>


// WEBPACK FOOTER //
// src/manage/getdatadetail/GetDataDetail.vue